<ion-card>
  <ion-card-header>
    <ion-card-title>Belépési fiókok</ion-card-title>
    <ion-card-subtitle>Kinek van egyáltalán belépése — és importfájl a hiányzókhoz</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div *ngIf="toltodik"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>

    <ng-container *ngIf="!toltodik">
      <ion-note color="medium" style="display:block;margin-bottom:14px" *ngIf="sulinform">
        A rendszer <b>két külön nyilvántartásból</b> áll: a törzsadatból (ki a gondviselő,
        ki a dolgozó) és a belépési rendszerből (kinek van fiókja). A kettő csendben
        elcsúszhat — a gondviselő minden adata rendben van, mégsem tud belépni. Ez a
        képernyő összeveti a kettőt.
      </ion-note>
      <!-- Az iskolán kívül nincs gondviselő és tanuló: csak munkatárs és ügyfél. -->
      <ion-note color="medium" style="display:block;margin-bottom:14px" *ngIf="!sulinform">
        A rendszer <b>két külön nyilvántartásból</b> áll: a törzsadatból (ki a munkatárs,
        ki az ügyfél) és a belépési rendszerből (kinek van fiókja). A kettő csendben
        elcsúszhat — a felhasználó minden adata rendben van, mégsem tud belépni. Ez a
        képernyő összeveti a kettőt.
      </ion-note>

      <!-- HOZZÁFÉRÉS. Alapból be van csukva: a legtöbbször nem kell hozzányúlni,
           mert a telepítés adataiból kitöltöttük. -->
      <div class="kc-fej">
        <ion-button size="small" fill="clear" (click)="beallitasNyitva = !beallitasNyitva">
          <ion-icon slot="start" [name]="beallitasNyitva ? 'chevron-down-outline' : 'chevron-forward-outline'"></ion-icon>
          Kapcsolat a belépési rendszerhez
        </ion-button>
        <span class="kc-cim" *ngIf="!beallitasNyitva && b.alapcim">{{ b.alapcim }} · {{ b.realm }}</span>
      </div>

      <div *ngIf="beallitasNyitva" class="kc-beallitas">
        <ion-grid>
          <ion-row>
            <ion-col size="12" sizeMd="6">
              <ion-input label="Cím" label-placement="stacked" fill="outline"
                         placeholder="https://idp.pelda.hu" [(ngModel)]="b.alapcim"></ion-input>
            </ion-col>
            <ion-col size="6" sizeMd="3">
              <ion-input label="Realm" label-placement="stacked" fill="outline"
                         [(ngModel)]="b.realm"></ion-input>
            </ion-col>
            <ion-col size="6" sizeMd="3">
              <ion-input label="Kliens" label-placement="stacked" fill="outline"
                         [(ngModel)]="b.kliens"></ion-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="12" sizeMd="6">
              <ion-input label="Adminisztrátor" label-placement="stacked" fill="outline"
                         [(ngModel)]="b.felhasznalo"></ion-input>
            </ion-col>
            <ion-col size="12" sizeMd="6">
              <ion-input label="Jelszó" label-placement="stacked" fill="outline" type="password"
                         [placeholder]="jelszoBeallitva ? 'beállítva – üresen hagyva marad' : 'nincs beállítva'"
                         [(ngModel)]="jelszo"></ion-input>
            </ion-col>
          </ion-row>
        </ion-grid>
        <ion-note color="medium" style="display:block;font-size:12px;margin-bottom:10px">
          Csak <b>olvasásra</b> használjuk: a fiókok listázásához. A rendszer soha nem hoz
          létre és nem módosít fiókot magától — az importfájlt a belépési rendszer saját
          felületén, tudatosan kell betölteni.
        </ion-note>
        <div class="kc-gombok">
          <ion-button color="primary" size="small" [disabled]="ment" (click)="mentes()">
            <ion-icon slot="start" name="save-outline"></ion-icon>{{ ment ? 'Mentés…' : 'Mentés' }}
          </ion-button>
          <ion-button fill="outline" size="small" [disabled]="tesztFut" (click)="teszt()">
            <ion-icon slot="start" name="pulse-outline"></ion-icon>
            {{ tesztFut ? 'Ellenőrzés…' : 'Kapcsolat ellenőrzése' }}
          </ion-button>
        </div>
        <ion-note *ngIf="eredmeny" [color]="eredmeny.ok ? 'success' : 'danger'"
                  style="display:block;margin-top:10px">
          {{ eredmeny.szoveg }}
        </ion-note>
      </div>

      <!-- ÖSSZEVETÉS -->
      <div class="kc-valaszto">
        <ion-segment *ngIf="sulinform" [(ngModel)]="fajta" (ngModelChange)="osszevetes = null; importEredmeny = null">
          <ion-segment-button value="gondviselo"><ion-label>Gondviselők</ion-label></ion-segment-button>
          <ion-segment-button value="dolgozo"><ion-label>Dolgozók</ion-label></ion-segment-button>
          <ion-segment-button value="tanulo"><ion-label>Tanulók</ion-label></ion-segment-button>
        </ion-segment>
        <ion-button color="primary" [disabled]="ellenorzesFut" (click)="ellenoriz()">
          <ion-icon slot="start" name="search-outline"></ion-icon>
          {{ ellenorzesFut ? 'Ellenőrzés…' : 'Ellenőrzés' }}
        </ion-button>
      </div>

      <ng-container *ngIf="osszevetes">
        <div class="kc-osszegzo">
          <div class="kc-szam">
            <b>{{ osszevetes.osszes }}</b><span>{{ sulinform ? osszevetes.fajta_nev.toLowerCase() : 'munkatárs és ügyfél' }} a törzsadatban</span>
          </div>
          <div class="kc-szam ok">
            <b>{{ osszevetes.van }}</b><span>van belépése</span>
          </div>
          <div class="kc-szam hiany">
            <b>{{ osszevetes.hianyzik }}</b><span>nincs belépése</span>
          </div>
          <div class="kc-szam tiltott" *ngIf="osszevetes.tiltott">
            <b>{{ osszevetes.tiltott }}</b><span>fiókja letiltva</span>
          </div>
        </div>

        <div class="kc-szurosor">
          <ion-input label="Keresés" label-placement="stacked" fill="outline"
                     placeholder="név, azonosító vagy e-mail" [(ngModel)]="szuro"></ion-input>
          <ion-item lines="none">
            <ion-toggle [(ngModel)]="csakHianyzo" labelPlacement="start">Csak a hiányzók</ion-toggle>
          </ion-item>
        </div>

        <div class="kc-lista">
          <div class="kc-sor" *ngFor="let t of szurtTetelek" [class.kc-hianyzik]="!t.van">
            <ion-icon [name]="t.van ? (t.engedelyezve === false ? 'lock-closed-outline' : 'checkmark-circle') : 'close-circle'"
                      [color]="t.van ? (t.engedelyezve === false ? 'warning' : 'success') : 'danger'"></ion-icon>
            <div class="kc-sor-nev">
              <b>{{ t.teljes_nev || t.azonosito }}</b>
              <div class="kc-sor-adat">
                <code>{{ t.azonosito }}</code>
                <span *ngIf="t.email"> · {{ t.email }}</span>
                <span *ngIf="!t.email" class="kc-nincs-email"> · nincs e-mail címe</span>
              </div>
              <div class="kc-sor-megj" *ngIf="t.csak_email">
                A fiók <b>más néven</b> létezik: <code>{{ t.kc_username }}</code> — az e-mail cím alapján találtuk meg.
              </div>
              <div class="kc-sor-megj" *ngIf="t.van && t.engedelyezve === false">
                A fiók létezik, de <b>le van tiltva</b> — így nem tud belépni.
              </div>
            </div>
          </div>
          <div class="kc-ures" *ngIf="!szurtTetelek.length">
            {{ csakHianyzo ? 'Mindenkinek van belépése.' : 'Nincs találat.' }}
          </div>
        </div>

        <!-- IMPORTFÁJL -->
        <div class="kc-import" *ngIf="osszevetes.hianyzik">
          <h3>Importfájl a hiányzókhoz</h3>
          <p>
            A fájl a belépési rendszer <b>„Partial import"</b> funkciójába tölthető be. A rendszer
            magától <b>nem hoz létre fiókot</b> — a betöltés tudatos, visszavonhatatlan lépés,
            ezért marad a te kezedben.
          </p>
          <ion-item lines="none" class="kc-kapcsolo">
            <ion-toggle [(ngModel)]="jelszavas" labelPlacement="start">
              Ideiglenes jelszó is készüljön
            </ion-toggle>
          </ion-item>
          <ion-note color="medium" style="display:block;font-size:12px;margin-bottom:10px">
            <b>Bekapcsolva:</b> a fiók azonnal használható, az első belépéskor a rendszer jelszó-cserét
            kér. A kezdő jelszó a <b>születési dátum</b> ÉÉÉÉHHNN alakban (pl. <code>20000526</code>) —
            ezt a felhasználó fejből tudja, tehát <b>nem kell kiosztani</b>. Akinek nincs rögzítve a
            születési dátuma, az véletlen számsort kap; azt viszont át kell adni, ezért a lista külön
            jelöli.
            <b>Kikapcsolva:</b> a fiók létrejön, de belépni csak jelszó-visszaállítás után lehet
            (ehhez e-mail cím kell).
          </ion-note>

          <ion-button color="primary" [disabled]="importFut" (click)="importKeszit()">
            <ion-icon slot="start" name="construct-outline"></ion-icon>
            {{ importFut ? 'Készül…' : 'Importfájl készítése (' + osszevetes.hianyzik + ' fiók)' }}
          </ion-button>

          <div *ngIf="importEredmeny?.hianyzik" class="kc-import-kesz">
            <ion-note color="success" style="display:block;margin-bottom:8px">
              Elkészült: <b>{{ importEredmeny.hianyzik }}</b> fiók.
            </ion-note>
            <div class="kc-gombok">
              <ion-button size="small" fill="outline" (click)="letoltJson()">
                <ion-icon slot="start" name="download-outline"></ion-icon>Importfájl (JSON)
              </ion-button>
              <ion-button size="small" fill="outline" color="warning"
                          *ngIf="importEredmeny.jelszavak?.length" (click)="letoltJelszavak()">
                <ion-icon slot="start" name="key-outline"></ion-icon>
                Jelszólista (CSV) — {{ importEredmeny.jelszavak.length }} db
              </ion-button>
            </div>
            <ion-note color="danger" *ngIf="kiosztandoJelszavak"
                      style="display:block;margin-top:8px;font-size:12px">
              <b>{{ kiosztandoJelszavak }}</b> olyan fiók van, amelynek nincs rögzített születési
              dátuma — ezek <b>véletlen</b> jelszót kaptak, és azt tényleg ki kell osztani. Ezt a
              listát <b>most</b> töltsd le: a véletlen jelszavak sehol nem tárolódnak, újbóli
              generálásnál másikat kapsz, ami már nem egyezik a betöltött fiókokéval.
            </ion-note>
            <ion-note color="medium" *ngIf="importEredmeny.jelszavak?.length && !kiosztandoJelszavak"
                      style="display:block;margin-top:8px;font-size:12px">
              Minden fiók a <b>születési dátumát</b> kapta kezdő jelszónak, tehát nincs mit kiosztani.
              A lista így is letölthető, ha ellenőrizni szeretnéd.
            </ion-note>

            <!-- E-MAIL ÜTKÖZÉS. Ez okozta a „duplicate resource" hibát: a belépési rendszer
                 a címet egyedinek tekinti, a törzsadatban viszont lehet közös postafiók. -->
            <div class="kc-utkozes" *ngIf="importEredmeny.email_utkozes?.length">
              <ion-note color="warning" style="display:block;font-size:12px">
                <b>{{ importEredmeny.email_utkozes.length }}</b> embernél ugyanaz az e-mail cím
                szerepel, mint egy másiknál. A belépési rendszer a címet <b>egyedinek</b> tekinti,
                ezért ezeknél a cím <b>kimaradt</b> az importból — a fiók létrejön, és a belépési
                azonosítóval használható, csak cím nélkül. Ha kell nekik a cím, a törzsadatban
                érdemes külön címet rögzíteni.
              </ion-note>
              <ul class="kc-utkozes-lista">
                <li *ngFor="let u of importEredmeny.email_utkozes">
                  <b>{{ u.teljes_nev }}</b> ({{ u.azonosito }}) — {{ u.email }},
                  ütközik vele: {{ u.utkozik_vele }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ion-card-content>
</ion-card>

<!--  E-MAIL NÉLKÜLI FIÓKOK.
      Van fiókja, de nincs rajta cím – a jelszó-visszaállító levél így soha nem érkezik
      meg. A szülő ezt úgy éli meg, hogy „kértem új jelszót, de nem jött".
      Gondviselő csak az iskolában (SULINFORM) van, máshol a kártya elmarad. -->
<ion-card *ngIf="sulinform">
  <ion-card-header>
    <ion-card-title>E-mail nélküli gondviselői fiókok</ion-card-title>
    <ion-card-subtitle>Ezekre a fiókokra nem érkezik jelszó-visszaállító levél</ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <ion-note color="medium" style="display:block;font-size:12px;margin-bottom:12px">
      A pótlás a <b>törzsadatban rögzített e-mail címet és nevet</b> írja a belépési fiókra. A jelszóhoz
      nem nyúl, és levelet sem küld: utána a szülő a belépőoldalon az <b>„Elfelejtetted?"</b> hivatkozással,
      a saját címével kérhet új jelszót. A <b>bizonytalan</b> tételeknél a fiókon másik ember neve áll,
      akinek nincs másik működő fiókja — ezeket csak kijelölve írjuk át.
    </ion-note>

    <div class="kc-gombok" style="margin-bottom:10px">
      <ion-button size="small" fill="outline" [disabled]="emailPotlasFut" (click)="emailPotlasBetolt()">
        <ion-icon slot="start" name="search-outline"></ion-icon>
        {{ emailPotlasFut ? 'Ellenőrzés…' : 'Ellenőrzés' }}
      </ion-button>
      <ion-button size="small" color="primary" *ngIf="emailPotlas"
                  [disabled]="emailPotlasFut || !(emailPotlas.potolhato + emailPotlasKijelolt.size)"
                  (click)="emailPotlasVegrehajt()">
        <ion-icon slot="start" name="mail-outline"></ion-icon>
        Pótlás ({{ emailPotlas.potolhato + emailPotlasKijelolt.size }} fiók)
      </ion-button>
    </div>

    <ng-container *ngIf="emailPotlas">
      <div class="kc-osszegzo">
        <div class="kc-szam ok"><b>{{ emailPotlas.potolhato }}</b><span>pótolható</span></div>
        <div class="kc-szam tiltott"><b>{{ emailPotlas.bizonytalan }}</b><span>bizonytalan</span></div>
        <div class="kc-szam hiany"><b>{{ emailPotlas.utkozes + emailPotlas.kozos_cim + emailPotlas.nincs_cim }}</b><span>nem pótolható</span></div>
      </div>
      <div class="kc-hiany">
        <table class="kc-tabla">
          <thead>
            <tr><th></th><th>Belépési név</th><th>Fiókon most</th><th>Törzsadat szerint</th><th>Megjegyzés</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let t of emailPotlasRendezett">
              <td>
                <ion-checkbox *ngIf="t.allapot === 'bizonytalan'"
                              [checked]="emailPotlasKijelolt.has(t.azonosito)"
                              (ionChange)="emailPotlasJelol(t, $event.detail.checked)"></ion-checkbox>
                <ion-icon *ngIf="t.allapot === 'potolhato'" name="checkmark-circle" color="success"></ion-icon>
                <ion-icon *ngIf="t.allapot !== 'potolhato' && t.allapot !== 'bizonytalan'" name="close-circle" color="danger"></ion-icon>
              </td>
              <td><code>{{ t.azonosito }}</code></td>
              <td>{{ t.fiok_nev || '—' }}</td>
              <td>{{ t.uj_nev }}<br><span class="kc-sor-adat">{{ t.uj_email || 'nincs e-mail' }}</span></td>
              <td>{{ t.ok }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ion-note *ngIf="emailPotlasEredmeny" [color]="emailPotlasEredmeny.sikeres === emailPotlasEredmeny.osszes ? 'success' : 'warning'"
              style="display:block;margin-top:10px">
      Kész: {{ emailPotlasEredmeny.sikeres }} / {{ emailPotlasEredmeny.osszes }} fiók kapott e-mail címet.
    </ion-note>
  </ion-card-content>
</ion-card>

<!--  BEKÖTÉSEK.
      A belépési név és a nyilvántartásbeli azonosító nem mindig ugyanaz. Ha a rendszer
      egyértelműen fel tudja oldani, magától összeköti a kettőt – amit nem tud, az itt
      munkalista lesz. Enélkül a felhasználó kapott egy érthetetlen hibaüzenetet, mi
      pedig nem is tudtunk róla. -->
<ion-card>
  <ion-card-header>
    <ion-card-title>Bekötések</ion-card-title>
    <ion-card-subtitle>Melyik belépési név kit jelent a nyilvántartásban</ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <div class="kc-sor" style="margin-bottom:10px">
      <ion-button size="small" fill="outline" [disabled]="bekotesFut" (click)="bekotesekBetolt()">
        <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
      </ion-button>
    </div>

    <ion-note color="medium" style="display:block;font-size:12px;margin-bottom:12px">
      A rendszer <b>magától</b> összeköti a belépési fiókot a nyilvántartásbeli személlyel, ha az
      egyértelmű — a felhasználónak nem kell szólnia, és nem kap hibaüzenetet.
      <ng-container *ngIf="sulinform">Tipikus eset a
      gondviselő: a törzsadata az <b>egyik</b> gyereke azonosítóján áll, a belépési fiókja a
      <b>másikén</b>.</ng-container> A bekötés nem ír át semmit, csak összeköt, ezért bármikor visszavonható.
    </ion-note>

    <!-- AMIT NEM TUDTUNK MEGOLDANI: ez a munkalista, ezért van elöl. -->
    <div class="kc-hiany" *ngIf="bekotesHianyzo.length">
      <ion-note color="warning" style="display:block;font-size:12px;margin-bottom:6px">
        <b>{{ bekotesHianyzo.length }}</b> fiók be tud lépni, de a nyilvántartásban nem találjuk —
        ezeket <b>emberi kézzel</b> kell rendbe tenni: vagy hiányzik a személy a törzsadatból, vagy
        több emberre is illene a fiók. Amíg ez fennáll, ők belépéskor azt látják, hogy még nem
        találjuk őket.
      </ion-note>
      <table class="kc-tabla">
        <thead>
          <tr><th>Belépési név</th><th>Mi az akadály</th><th>Próbálkozás</th><th>Utoljára</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let b of bekotesHianyzo">
            <td><code>{{ b.username }}</code></td>
            <td>{{ b.magyarazat }}</td>
            <td>{{ b.probalkozas }}</td>
            <td>{{ b.utoljara | date:'yyyy.MM.dd. HH:mm' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="kc-hiany" *ngIf="bekotve.length">
      <h4 style="margin:16px 0 6px;font-size:13px">Bekötve ({{ bekotve.length }})</h4>
      <table class="kc-tabla">
        <thead>
          <tr><th>Belépési név</th><th>Kit jelent</th><th>Miből tudjuk</th><th>Utoljára</th><th></th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let b of bekotve">
            <td><code>{{ b.username }}</code></td>
            <td>{{ b.fajta }} — <code>{{ b.azonosito }}</code></td>
            <td>{{ b.mod }}</td>
            <td>{{ b.utoljara | date:'yyyy.MM.dd. HH:mm' }}</td>
            <td>
              <ion-button size="small" fill="clear" color="danger" (click)="bekotestVisszavon(b)">
                Visszavonás
              </ion-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="kc-ures" *ngIf="!bekotesFut && !bekotesek.length">
      Nincs bekötés — a belépési nevek és a nyilvántartás azonosítói egyeznek.
    </div>
  </ion-card-content>
</ion-card>
